import {AnyEvent, JOB_SECTION_ITEM_STATUS_UPDATED, JobSectionItemStatusUpdatedEvent} from '../type';

export default function jobSectionItemStatusUpdated(payload: JobSectionItemStatusUpdatedEvent['payload']): AnyEvent {
  return {
    type: JOB_SECTION_ITEM_STATUS_UPDATED,
    payload,
  }
}